import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Er du sikker på, at du vil deaktivere live-bestillinger?',
    enable: 'Er du sikker på, at du vil slå live-bestillinger TIL?',
  },
  form: {
    is_google_business_available: {
      label: 'Google Business tilgængelig',
    },
    is_smart_pricing_configured: {
      label: 'Billigere priser end Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Reklameflyer sendt',
    },
    is_menu_fully_configured: {
      label: 'Alle menupunkter er tilgængelige',
    },
    has_offers_on_competitor_platforms: {
      label: 'Har restauranten tilbud kørende på Wolt, Uber, Lieferando (undtagen tilbud om gratis levering)?',
    },
    is_instagram_story_shared: {
      label: 'Instagram-story delt med ejeren',
    },
    is_order_system_connected_to_website: {
      label:
        'Foodamigos-hjemmeside forbundet ELLER restaurantens egen hjemmeside har fået knappen til online bestilling',
    },
    google_business_connected_by: {
      label: 'Hvordan fik vi adgang til Google Business-profilen?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Salgschef har inviteret google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Salgschef har selv sendt den første anmodning fra ejerens telefon',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Onboarding-manager har anmodet om Google Business-profilen (salgschef inviterede ikke og anmodede ikke om adgang)',
      },
    },
  },
  labels: {
    successful_launch:
      'For at sikre en vellykket lancering bedes du gennemgå og håndtere følgende åbne punkter. Kontrol af \n' +
      'disse oplysninger er med til at undgå potentielle problemer, når restauranten går live.',
    check_errors: 'Tjek fejlene for at sikre en god lancering af restauranten.',
    checkbox_confirmation:
      'Jeg bekræfter, at jeg har gennemgået fejlene, og samtykker til aktivering af denne restaurant.',
  },
  buttons: {
    check_error: 'Tjek fejl',
    confirm_and_activate: 'Bekræft og aktivér',
    cancel: 'Annuller',
    yes: 'Ja',
    no: 'Nej',
  },
  errors: {
    name: {
      title: 'Ingen arabiske, kinesiske osv. tegn i shoppens navn',
      description: 'Onlineshoppens navn indeholder ikke-latinske tegn',
    },
    logo_url: {
      title: 'Logo',
      description: 'Logo er uploadet til onlineshoppen',
    },
    pictures: {
      title: 'Galleribillede',
      description: '≥ 1 galleribillede er tilgængeligt i onlineshoppen',
    },
    menu_uploaded: {
      title: 'Menu uploadet',
      description: '≥ 1 menu er tilgængelig',
    },
    opening_hours: {
      title: 'Åbningstider',
      description: '≥ 1 åbningstid tilføjet',
    },
    address: {
      title: 'Restaurantens adresse',
      description: 'Gade, by og postnummer er indtastet',
    },
    upsell_items: {
      title: 'Mersalgsprodukter',
      description: '≥ 3 mersalgsprodukter er valgt',
    },
    master_promo_code: {
      title: 'Master-rabatkode',
      description: 'Master-rabatkode er tilgængelig',
    },
    flyers_ordered: {
      title: 'Flyers bestilt',
      description: '≥ 1 flyerpakke bestilt',
    },
    test_orders: {
      title: 'Testordre sendt',
      description: '≥ 1 testordre er afgivet',
    },
    stripe_billing: {
      title: 'Stripe-konto',
      description: 'Stripe-konto forbundet',
    },
    payments_configured: {
      title: 'Betalinger konfigureret',
      description: 'Partneren har forbundet en betalingsudbyder – påkrævet, før man kan gå live',
    },
    adyen_merchant_account: {
      title: 'Adyen-forhandlerkonto',
      description: 'En aktiv forhandlerkonto for denne restaurants land – påkrævet for indenlandske kortpriser',
    },
    payment_rail_covers_country: {
      title: 'Betalingsrail dækker landet',
      description: 'Partnerens betalingskonti kan behandle betalinger i denne restaurants land',
    },
    identity: {
      title: 'Restaurantens identitet',
      description: 'Restauranttype og køkken er angivet',
    },
    storefront: {
      title: 'Storefront oprettet og domæne forbundet',
      description: 'Kun hvis restauranten vil bruge vores hjemmeside',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business forbundet',
    },
    billing_payment_method: {
      title: 'Betalingsmetode',
      description: 'Tilføj en betalingsmetode, så FoodAmigos kan fakturere denne restaurant månedligt.',
    },
    billing_license: {
      title: 'Licens',
      description: 'Denne restaurant skal have en partnerplan, før den kan gå live.',
    },
    business_name: {
      title: 'Virksomheds-/restaurantnavn',
      description: 'Navnet, der vises i brugsvilkårene og privatlivspolitikken, er gemt',
    },
    payment_method: {
      title: 'Kontant eller onlinebetaling',
      description: 'Kontant betaling ved afhentning eller levering er slået til, eller onlinebetalinger er verificeret',
    },
    stripe_processing_fee: {
      title: 'Behandlingsgebyr',
      description: 'Partneren har fastsat sit Stripe-behandlingsgebyr eller bekræftet 0 % margin',
    },
  },
};
